import React from 'react';

//compoenents
import { CpdsCardCta } from '../styles/card-component';

//types
import { CpdsCardCtaProps } from '../typings';

const CardActionWrapper: React.FC<CpdsCardCtaProps> = (props) => {
  const { exClasses, styleOverrides, children, ...rest } = props;

  return (
    <CpdsCardCta key="cpds-action-conatiner" styleOverrides={styleOverrides} className={exClasses} {...rest}>
      {children}
    </CpdsCardCta>
  );
};
CardActionWrapper.displayName = "CardActionWrapper";
export { CardActionWrapper };
